// extracted by mini-css-extract-plugin
export default {"wrapper":"UnorderedList_wrapper__OfXm3","item":"UnorderedList_item__1eFxW"};